import React, { useState } from "react";
import { Row, Col, Card, Input, Button, Typography, App, Space } from "antd";
import axios from "axios";
import "./QRLink.css";
import HeaderLayout from "../../components/Header";
import FooterLayout from "../../components/Footer";
import PageHeader from "../../components/PageHeader";
import { QRCodeCanvas } from "qrcode.react";

const { Title, Paragraph } = Typography;

const QRLink = () => {
  const { notification, message } = App.useApp();
  const [name, setName] = useState("");
  const [link, setLink] = useState("");
  const [qrUrl, setQrUrl] = useState("");
  const isModule = window.location.pathname.includes("/dashboard/");

  const generateQR = async () => {
    const isModule = window.location.pathname.includes("/dashboard/");
    const authToken = localStorage.getItem("token");
    try {
      const response = await axios.post(
        isModule
          ? `${process.env.REACT_APP_BASE_URL}/api/QR/link-to-qr`
          : `${process.env.REACT_APP_BASE_URL}/api/WebsiteQr/website-link-to-qr`,
        {
          link: link,
          title: name,
          access_source: isModule ? "Private-Web" : "Public-Web",
          qrtext: "",
        },
        {
          headers: isModule
            ? {
                Authorization: `Bearer ${authToken}`,
              }
            : {},
        }
      );
      if (response.data.error === false) {
        setQrUrl(link);
      }
    } catch (error) {
      message.error("Failed to generate QR code");
    }
  };

  const downloadQR = () => {
    const [canvas] = document.getElementsByTagName("canvas");
    const pngUrl = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.download = "qr-code.png";
    link.href = pngUrl;
    link.click();
  };

  return (
    <>
      {isModule ? <PageHeader /> : <HeaderLayout />}
      <div className="qr-container">
        <Row gutter={24}>
          <Col flex={3}>
            <Card className="qr-card" style={{ height: "100%" }}>
              <Title level={5}>Generate QR</Title>
              <br />
              <div className="form-group">
                <label>Name of your QR code</label>
                <Input
                  placeholder="Enter name of your QR code"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Website URL</label>
                <Input
                  placeholder="E.g. https://www.myweb.com"
                  value={link}
                  onChange={(e) => setLink(e.target.value)}
                />
              </div>
              <br />
              <Space size={"middle"}>
                <Button type="primary" onClick={generateQR}>
                  Generate QR
                </Button>
                {qrUrl && (
                  <Button type="primary" onClick={downloadQR}>
                    Download QR
                  </Button>
                )}
              </Space>
            </Card>
          </Col>
          <Col>
            <Card className="qr-preview-card">
              {qrUrl ? (
                <Col align="middle">
                  <QRCodeCanvas value={qrUrl} size={300} />
                </Col>
              ) : (
                <div className="qr-placeholder" />
              )}
              <Title level={5} style={{ marginTop: 16 }}>
                Generated QR Code
              </Title>
              <Paragraph>
                Your QR code will be displayed here once generated.
              </Paragraph>
            </Card>
          </Col>
        </Row>
      </div>
      {!isModule && <FooterLayout />}
    </>
  );
};

export default QRLink;
